module.exports = __webpack_public_path__ + "img/clock_1.7d2cf471.png";